import dayjs from 'dayjs'
import type { InGameMessageWithTree } from '../types/inGameMessages'

const MAX_TIMESTAMP = 8.64e15

function isWithinWindow(startsAt: string | null | undefined, endsAt: string | null | undefined, now: number): boolean {
    const start = startsAt ? dayjs(startsAt).valueOf() : 0
    const end = endsAt ? dayjs(endsAt).valueOf() : MAX_TIMESTAMP

    if (Number.isNaN(start) || Number.isNaN(end)) return false

    return start <= now && now <= end
}

export interface InGameMessageFilter {
    gameSlug: string
    now: number
}

export function matchInGameMessages(
    messages: readonly InGameMessageWithTree[],
    { gameSlug, now }: InGameMessageFilter,
): InGameMessageWithTree[] {
    return messages.filter((message) => {
        if (message.game_slugs?.length && !message.game_slugs.includes(gameSlug)) return false

        return isWithinWindow(message.starts_at, message.ends_at, now)
    })
}
